import { render } from "./VideoConsent.vue?vue&type=template&id=4caea66a"
import script from "./VideoConsent.vue?vue&type=script&lang=js"
export * from "./VideoConsent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__